import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
var SubmitToEmployer = /*#__PURE__*/function (_Component) {
  function SubmitToEmployer(props) {
    var _this;
    _classCallCheck(this, SubmitToEmployer);
    _this = _callSuper(this, SubmitToEmployer, [props]);
    _this.state = {
      text: props.advisorRemark
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(SubmitToEmployer, _Component);
  return _createClass(SubmitToEmployer, [{
    key: "buildSubmitOnBehalfStr",
    value: function buildSubmitOnBehalfStr() {
      var resubmit = this.props.resubmit;
      return "".concat(resubmit ? 'Resubmit' : 'Submit', " to Employer");
    }
  }, {
    key: "buildSubmitOnBehalfWarning",
    value: function buildSubmitOnBehalfWarning() {
      var _this$props = this.props,
        onBehalf = _this$props.onBehalf,
        resubmit = _this$props.resubmit;
      return "Are you sure you want to ".concat(resubmit ? 'resubmit' : 'submit', " this proposal to the employer").concat(onBehalf ? ' on behalf of the consultant' : '', "? ").concat(onBehalf ? 'The consultant has not yet had a chance to review and submit on their own.' : '');
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.value;
      var name = target.name;
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$props2 = this.props,
        formUrl = _this$props2.formUrl,
        csrfToken = _this$props2.csrfToken,
        handleProposalAfterSubmit = _this$props2.handleProposalAfterSubmit,
        showNewProposalUX = _this$props2.showNewProposalUX;
      var data = this.state;
      return putRequest(formUrl, data, csrfToken).then(function (res) {
        if (showNewProposalUX) {
          handleProposalAfterSubmit(res.data);
        } else {
          window.location.reload();
        }
      })["catch"](function (err) {
        _this2.setState({
          errors: err
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        submitButtonText = _this$props3.submitButtonText,
        triggerType = _this$props3.triggerType,
        buttonStyles = _this$props3.buttonStyles;
      var text = this.state.text;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: this.buildSubmitOnBehalfStr(),
        buttonStyles: buttonStyles,
        submitButtonText: submitButtonText,
        handleSubmit: this.handleSubmit,
        headerTitle: /*#__PURE__*/React.createElement("strong", null, "Confirm proposal submission"),
        triggerType: triggerType,
        idKey: "submit-to-employer",
        cloneContent: false,
        closeAfterSubmit: true
      }, /*#__PURE__*/React.createElement("p", null, this.buildSubmitOnBehalfWarning()), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Reminder: check if the Consultant Referral Agreement was signed")), /*#__PURE__*/React.createElement("div", {
        className: "mt-12 mb-12"
      }, "Remarks about the consultant for the employer:"), /*#__PURE__*/React.createElement("textarea", {
        value: text || '',
        className: "form-control",
        placeholder: "Consultant is a ...",
        name: "text",
        id: "text",
        rows: "4",
        onChange: this.handleInputChange
      }));
    }
  }]);
}(Component);
SubmitToEmployer.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  submitButtonText: PropTypes.string,
  triggerType: PropTypes.string,
  resubmit: PropTypes.bool,
  onBehalf: PropTypes.bool,
  advisorRemark: PropTypes.string,
  buttonStyles: PropTypes.string,
  handleProposalAfterSubmit: PropTypes.func,
  showNewProposalUX: PropTypes.bool
};
SubmitToEmployer.defaultProps = {
  submitButtonText: 'Yes, submit',
  triggerType: 'button',
  resubmit: false,
  onBehalf: false,
  advisorRemark: '',
  buttonStyles: 'danger',
  handleProposalAfterSubmit: function handleProposalAfterSubmit() {},
  showNewProposalUX: false
};
export default SubmitToEmployer;